import type { Parent, Profile } from "@spork/s4p-server-sdk";

export type ParentCardInfo = {
    name: string;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
};

function formatPersonName(
    firstName: string | null,
    lastName: string | null,
    fullName?: string | null,
): string {
    return fullName || `${firstName ?? ""} ${lastName ?? ""}`.trim();
}

/**
 * Resolves the signed-in parent's display fields from the profile list,
 * falling back to the auth session when the profile has not loaded yet.
 */
export function resolveParentCardInfo(
    authContext: Parent | null | undefined,
    profiles: Profile[] | undefined,
): ParentCardInfo | null {
    if (!authContext) {
        return null;
    }

    const profile = profiles?.find(
        (item) => item.id === authContext.pipedrive_id,
    );
    const firstName = profile?.first_name ?? authContext.first_name;
    const lastName = profile?.last_name ?? authContext.last_name;

    return {
        name: formatPersonName(firstName, lastName, authContext.full_name),
        email: authContext.email ?? profile?.email,
        firstName,
        lastName,
    };
}
